import { HeaderPanel } from "../../HeaderPanel";
import React, { useCallback } from "react";
import { headerPanelOptions } from "./panelSettings";
import './Actions.less'

export function ActionsPanel({ getActionHolder }: any) {
    const actionsHolder = useCallback(
      (node: HTMLDivElement) => {
        getActionHolder && getActionHolder(node);
      },
      [getActionHolder]
    );
  
    return (
      <HeaderPanel {...headerPanelOptions('secondary', 'Actions')}>
        <div className="dp-entitydetails-actions" ref={actionsHolder}></div>
      </HeaderPanel>
    );
  }
